// auto-generated by Typewriter template _models.tst from PortCall.Core.EndPoints\App\Account\AccountBindingModels.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// ChangePasswordRequestData is the class that ChangePasswordRequest serializes to/from
export interface ChangePasswordRequestData {
	
	
    ConfirmPassword : string | null;
    NewPassword : string;
    OldPassword : string;
}

// ChangePasswordRequestOptions is the class which may be passed to the ChangePasswordRequest constructor to define optional initial data values
export interface ChangePasswordRequestOptions {
	
	
    ConfirmPassword? : string | null;
    NewPassword? : string;
    OldPassword? : string;
}

export class ChangePasswordRequest {
	
	
    public ConfirmPassword : DataSignal<string | null>;
    public NewPassword : DataSignal<string>;
    public OldPassword : DataSignal<string>;

    constructor();
    constructor(data : ChangePasswordRequestOptions);
    constructor(data: ChangePasswordRequestOptions | null = null) {
	    
	    
        this.ConfirmPassword = jsonableObservable(S.value<string | null>(data && data.ConfirmPassword !== undefined ? data.ConfirmPassword : null));
        this.NewPassword = jsonableObservable(S.value<string>(data && data.NewPassword !== undefined ? data.NewPassword : ''));
        this.OldPassword = jsonableObservable(S.value<string>(data && data.OldPassword !== undefined ? data.OldPassword : ''));
    }

    static key(obj : ChangePasswordRequest) {
        return ;
    }
    
    static dataKey(obj : ChangePasswordRequestOptions) {
        return ;
    }

    static update(obj : ChangePasswordRequest, data : ChangePasswordRequestOptions) {
        S.freeze(() => {
	        
	        
            if (data.ConfirmPassword !== undefined) obj.ConfirmPassword(data.ConfirmPassword);
            if (data.NewPassword !== undefined) obj.NewPassword(data.NewPassword);
            if (data.OldPassword !== undefined) obj.OldPassword(data.OldPassword);
        });
    }
}

// LoginRequestData is the class that LoginRequest serializes to/from
export interface LoginRequestData {
	
	
    Password : string;
    UserName : string;
}

// LoginRequestOptions is the class which may be passed to the LoginRequest constructor to define optional initial data values
export interface LoginRequestOptions {
	
	
    Password? : string;
    UserName? : string;
}

export class LoginRequest {
	
	
    public Password : DataSignal<string>;
    public UserName : DataSignal<string>;

    constructor();
    constructor(data : LoginRequestOptions);
    constructor(data: LoginRequestOptions | null = null) {
	    
	    
        this.Password = jsonableObservable(S.value<string>(data && data.Password !== undefined ? data.Password : ''));
        this.UserName = jsonableObservable(S.value<string>(data && data.UserName !== undefined ? data.UserName : ''));
    }

    static key(obj : LoginRequest) {
        return ;
    }
    
    static dataKey(obj : LoginRequestOptions) {
        return ;
    }

    static update(obj : LoginRequest, data : LoginRequestOptions) {
        S.freeze(() => {
	        
	        
            if (data.Password !== undefined) obj.Password(data.Password);
            if (data.UserName !== undefined) obj.UserName(data.UserName);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ChangePasswordRequest.ts